/**
 * CRM 狀態 → StatusDot 色調對照（docs/介面優化.md R6，全 CRM 只在這裡定義一次）
 * success 完成／啟用、warning 待處理、danger 逾期／錯誤／失敗、neutral 草稿／停用、accent 進行中
 */
import type { StatusTone } from '@redpanda/ui';

export const quoteTone: Record<string, StatusTone> = {
  DRAFT: 'neutral',
  SENT: 'warning',
  ACCEPTED: 'success',
  COMPLETED: 'success',
  REJECTED: 'danger',
};

export const projectTone: Record<string, StatusTone> = {
  preparing: 'neutral',
  inProgress: 'accent',
  onHold: 'warning',
  completed: 'success',
  cancelled: 'neutral',
};

/** 任務優先級：色點＋字，不用彩色字（§3-10） */
export const priorityTone: Record<string, StatusTone> = {
  HIGH: 'danger',
  MEDIUM: 'warning',
  LOW: 'neutral',
};

export const toneOf = (map: Record<string, StatusTone>, value?: string): StatusTone =>
  (value && map[value]) || 'neutral';

/** 商機階段：成交（機率 100%）＝完成、機率 0（輸單）＝停用，其餘＝進行中 */
export const stageTone = (probability: number): StatusTone =>
  probability >= 1 ? 'success' : probability <= 0 ? 'neutral' : 'accent';
